//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { option } from '@/assets/js/area'
import { getServiceContent, getMajor, getServiceContents, getJobTitle } from '@/assets/js/dict';
import { downloadFile } from '@/assets/js/tool';
export default {
  created() {
    getServiceContent().then(res => {
      this.serviceContentArr = res;
    })
    getServiceContents().then(res => {
      this.serviceList = res
    })
    getMajor().then(res => {
      this.majorList = res
    })
    getJobTitle().then(res => {
      this.jobTitleList = res
    })
    var cityList = []
    for (var i = 0; i < option.length; i++) {
      for (var j = 0; j < option[i].citys.length; j++) {
        var obj = {}
        obj.name = option[i].citys[j].cityName
        cityList.push(obj)
      }
    }
    this.cityList = cityList
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      props: {
        multiple: true,
        checkStrictly: true
      },
      dialogVisibile: false,
      inputType:1,
      form: {
        approvalDepartment: '', //审批部门
        assessCompany: '', //评估公司名称
        client: '', //委托评估单位
        constructionCompany: '', //项目建设单位
        city: '', //市
        meetingPlace: '', //会议地点
        meetingTime: '', //会议时间
        orgCompany: '', //报告编制单位
        projectName: '', //项目名称
        serviceContent: '', //服务内容
        surveyMessage: '', //踏勘信息
        surveyTime: '',  //踏勘时间 
        expertParam: [
        ]
      },
      serviceContentArr: [],
      serviceList: [],
      majorList: [],
      cityList: [],
      jobTitleList: [],
      wordVisibile: false, // word预览弹窗
      contUrl: '', //预览文件地址
      wordUrl: '',
      pdfUrl: '',
      ts: '',
      info: '', //项目详情
      rules: {
        approvalDepartment: {
          required: true,
          message: '请填写审批部门',
          trigger: 'blur'
        },
        assessCompany: {
          required: true,
          message: '请填写评估公司名称',
          trigger: 'blur'
        },
        client: {
          required: true,
          message: '请填写委托评估单位',
          trigger: 'blur'
        },
        constructionCompany: {
          required: true,
          message: '请填写项目建设单位',
          trigger: 'blur'
        },
        city: {
          required: true,
          message: '请选择会议召开地',
          trigger: 'change'
        },
        meetingPlace: {
          required: true,
          message: '请填写会议地点',
          trigger: 'blur'
        },
        meetingTime: {
          required: true,
          message: '请选择会议时间',
          trigger: 'change'
        },
        orgCompany: {
          required: true,
          message: '请填写报告编制单位',
          trigger: 'blur'
        },
        projectName: {
          required: true,
          message: '请填写项目名称',
          trigger: 'blur'
        },
        serviceContent: {
          required: true,
          message: '请选择服务内容',
          trigger: 'change'
        },
        surveyTime: {
          required: true,
          message: '请选择踏勘时间',
          trigger: 'change'
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    //打开弹窗
    openDialog() {
      this.projectInfo()
      this.getPersonInfo()
      this.dialogVisibile = true
      this.inputType= 1
      this.form.approvalDepartment = '' //审批部门
      this.form.assessCompany = ''//评估公司名称
      this.form.client = '' //委托评估单位
      this.form.constructionCompany = ''//项目建设单位
      this.form.city = '' //市
      this.form.meetingPlace = '' //会议地点
      this.form.meetingTime = ''//会议时间
      this.form.orgCompany = '' //报告编制单位
      this.form.projectName = '' //项目名称
      this.form.serviceContent = '' //服务内容
      this.form.surveyMessage = '' //踏勘信息
      this.form.surveyTime = ''  //踏勘时间 
      this.contUrl = ''
    },

    // 项目详情
    projectInfo() {
      this.$get('/tra/project/detail?id=' + this.$route.query.id, function (res) {
        if (res.code == 200) {
          var info = res.data
          this.form.serviceContent = JSON.parse(info.serviceContent)
          this.form.meetingPlace = info.meetingPlace //会议地点
          this.form.meetingTime = info.meetingTime  //会议时间
          this.form.projectName = info.projectName  //项目名称
          this.form.surveyTime = info.surveyTime ? info.surveyTime : ''  //踏勘时间 
        }
      })
    },

    // 专家列表
    getPersonInfo() {
      let params = { projectId: this.$route.query.id }
      this.$get('/tra/project/bid/meetingList', params, function (res) {
        if (res.code == 200) {
          var list = res.data
          this.form.expertParam = []
          for (var i = 0; i < list.length; i++) {
            var obj = {}
            obj.nickName = list[i].nickName
            for (var j = 0; j < this.jobTitleList.length; j++) {
              if (this.jobTitleList[j].dictCode == list[i].jobTitle) {
                list[i].jobTitle = this.jobTitleList[j].dictName
              }
            }
            obj.title = list[i].jobTitle ? list[i].jobTitle : ''
            obj.company = list[i].workCompany ? list[i].workCompany : ''
            obj.workMajor = ''
            obj.workMajors = []
            var major = ''
            if (list[i].workMajor) {
              major = list[i].workMajor.split(',')
            }
            for (var j = 0; j < major.length; j++) {
              for (var k = 0; k < this.majorList.length; k++) {
                var objs = {}
                if (major[j] == this.majorList[k].dictCode) {
                  objs.dictCode = this.majorList[k].dictCode
                  objs.dictName = this.majorList[k].dictName
                  obj.workMajors.push(objs)
                }
              }
            }
            this.form.expertParam.push(obj)
          }
        }
      })
    },

    // 保存数据 生成word预览
    preview(forms) {
      var info = this.info
      this.$refs[forms].validate((valid) => {
        if (valid) {
          var form = JSON.parse(JSON.stringify(this.form))
          var serviceContent = form.serviceContent.toString().split(',')
          var content = ''
          for (var i = 0; i < this.serviceList.length; i++) {
            for (var j = 0; j < serviceContent.length; j++) {
              if (this.serviceList[i].dictCode == serviceContent[j]) {
                content += this.serviceList[i].dictName + ','
              }
            }
          }
          if (info.assessType == 2 && info.meetingType != 3 && info.isSurvey == true) {
            form.surveyMessage = '在现场踏勘的基础上'
            form.surveyTime = form.surveyTime.slice(0, form.surveyTime.length - 3)
          }
          form.serviceContent = content.slice(0, content.length - 1)
          form.meetingTime = form.meetingTime.slice(0, form.meetingTime.length - 3)
          var expertParam = form.expertParam
          for (var i = 0; i < expertParam.length; i++) {
            expertParam[i].title = expertParam[i].title + '工程师'
          }
          form.expertParam = expertParam
          this.$post('/tra/project/work/export', form, function (res) {
            if (res.code == 200) {
              this.ts = new Date().getTime()
              this.wordVisibile = true
              this.pdfUrl = res.data.pdfUrl
              this.wordUrl = res.data.wordUrl
              var href=''
              if(window.location.href.indexOf('yunzikongjian')!=-1){
                href=window.location.href.split('/wechat/#/outsourcer')[0];
              }else{
                href=window.location.href.split('/#/outsourcer')[0];
              }
              this.contUrl = href + res.data.pdfUrl
              this.inputType=2
            }
          }, true)
        }
      })
    },


    // 下载资料
    downloadUrl() {
      downloadFile(this.wordUrl, this.wordUrl.substring(this.wordUrl.lastIndexOf("/") + 1))
      this.dialogVisibile = false
    },


  }
}
